/** Schema version of the in-memory player. v2 = Corrupted-Data economy
 *  (was: CC + Decrypter network, removed in P2.A.5 sunset). */
export const GAME_VERSION = 2;

export const STARTING_CREDITS = 0;
export const STARTING_PREMIUM = 0;
export const STARTING_LEVEL = 1;
// Bumped 20 → 28 with the Vault-Knight set expansion (8 equipment slots,
// ~50 % more drops per run).
export const STARTING_INVENTORY_SLOTS = 28;

/** v2 economy starting values. */
export const STARTING_CLEAN_CODE = 0;  // legacy field, always 0 — keeps types valid for migration
export const STARTING_CORRUPTED_DATA = 0;
export const STARTING_NEON_GEMS = 0;

export const MAX_LEVEL = 100;

export function xpRequiredForLevel(level: number): number {
  if (level <= 1) return 0;
  return Math.floor(50 * Math.pow(level - 1, 1.5));
}
